export const parseInt10 = (string) => parseInt(string, 10);
